import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-detection_wall",
  "use": "icon-detection_wall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-detection_wall\"><path d=\"M341.207 910.843V726.538H75.228V480.707h265.979V358.994H75.228V113.157h605.517l.005 184.3h265.974v245.836H680.75v121.713h265.974v245.842H341.207zm542.92-62.597V727.603H403.804v120.643h480.323zm-265.98-184.3V543.304H137.826v120.642h480.323zm265.98-183.25V360.054H403.804v120.642h480.323zm-265.98-184.3V175.755H137.826v120.643h480.323z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol